<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div id='map' class='box'></div>
</template>
<script>
import world from "./world.json";
import * as echarts from "echarts";
import {getWorldMap} from "@/service/dashboard";
import {countryChineseDict, countryDict} from "@/theme/dict";

export default {
  props: ["activeScreen"],
  data() {
    return {
      myChart: null,
      unitManagementData: [],
      mapLineDataArr: [],
      option3 : {
        // 鼠标移上去时显示悬浮框
        tooltip: {
          zLevel:8,
          backgroundColor: "#929edc",
          padding: 8,
          trigger: "item", // 设置该属性之后，会与series中data数据对应。注意data中对象的键名为name。如果单纯的展示数据可用此属性，不与formatter同用。
          // 模板字符串渲染悬浮框，注意图片的引入方式（require）,否则无法显示。
          position: function (point) {
            // point 参数包含了数据点的坐标信息
            return [point[0] + 10, point[1] - 10]; // 根据数据点坐标调整位置
          },
          formatter: (params) => {
            // console.log(params);
            return `<div style="text-align: center;">
                      <p>国家:${countryChineseDict[params.name]}</p>
                      <p>${params.data.list[0].type}:
                      评分:${params.data.list[0].score}
                      重点机构域名:${params.data.list[0].asset_num}
                      防范措施部署:${params.data.list[0].asset_prac}</p>
                       <p>${params.data.list[1].type}:
                       评分:${params.data.list[1].score}
                      重点机构域名:${params.data.list[1].asset_num}
                      防范措施部署:${params.data.list[1].asset_prac}</p>
                       <p>${params.data.list[2].type}:
                       评分:${params.data.list[2].score}
                      重点机构域名:${params.data.list[2].asset_num}
                      防范措施部署:${params.data.list[2].asset_prac}</p>
                    <div>`;
          }
        },

        // 视觉映射组件
        visualMap: [{
          show: false,
          type: "continuous", // 类型为连续型
          min: 0,
          max: 0.6,
          // range: [100, 400],
          left: "left",
          top: "bottom",
          text: ["高", "低"], // 取值范围的文字
          textStyle: {
            color: "#fff"
          },
          inRange: {
            color: ["rgb(178,163,248)", "#370286"] // 取值范围的颜色

          }
        }],

        series: [
          {
            type: "map",
            name: "降水量",
            map: "world", // 这里的名称需要和 echarts.registerMap('china',{})中的名称一致
            roam: true, // 缩放
            zlevel: 1, // 设置图层堆叠顺序
            zoom: 1.2, // 默认地图在容器中显示zoom:1,可根据需求放大缩小地图
            label: {
              show: false, // 是否显示省份名称
              color: "#fff"
            },
            itemStyle: {
              areaColor: "#252531", // 地图区域背景颜色
              borderColor: "#ffffff" // 地图边界颜色
            },
            // 高亮时的设置
            emphasis: {
              // 高亮时地图区域背景颜色
              itemStyle: {
                areaColor: "pink"
              },
              // 文字颜色，样式在此处
              label: {
                color: "#fff"
              }
            },
            // 数据
            data: [
              { name: "South Africa", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "Uzbekistan", value: Math.round(Math.random() * 1000),type:"证书" },
              { name: "Uruguay", value: Math.round(Math.random() * 1000),type:"证书" },
              { name: "Russia", value: Math.round(Math.random() * 1000),type:"证书" },
              { name: "Uganda", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "Botswana", value: Math.round(Math.random() * 1000),type:"证书" },
              { name: "Bhutan", value: Math.round(Math.random() * 1000),type:"证书" },
              { name: "Angola", value: Math.round(Math.random() * 1000) ,type:"证书"},
              { name: "Bolivia", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "Bermuda", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "Belarus", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "Bahamas", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "Belgium", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "Australia", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "United Arab Emirates", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "China", value: Math.round(Math.random() * 1000),type:"综合" },
              { name: "Andorra", value: Math.round(Math.random() * 1000),type:"证书" },
              { name: "Albania", value: Math.round(Math.random() * 1000),type:"路由" },
              { name: "Serbia", value: Math.round(Math.random() * 1000),type:"路由" },
              { name: "W. Sahara", value: Math.round(Math.random() * 1000),type:"路由" },
              { name: "Morocco", value: Math.round(Math.random() * 1000),type:"路由" },
              { name: "Liechtenstein", value: Math.round(Math.random() * 1000),type:"路由" },
              { name: "Somalia", value: Math.round(Math.random() * 1000),type:"路由" },
              { name: "Afghanistan", value: Math.round(Math.random() * 1000) ,type:"路由"},
              { name: "Canada", value: Math.round(Math.random() * 1000),type:"路由" }
            ]
          }

        ]
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      getWorldMap().then(res => {
        //中国
        const arr = Object.keys(res);
        const countryList =Object.keys(res[arr[0]]);
        const resultArr = countryList.map(item => {
          const list = [];

          arr.forEach(i => {
            list.push({...res[i][item], type: i,value: res[i][item].score});
          });
          return {
            name: countryDict[item],
            list: list,
            value:list[0].value
          };
        });

        console.log(resultArr);
        // let cnData = {};
        // cnData.name = "China";
        // cnData.list = [];
        // let DNSSEC = res.DNSSEC.CN;
        // DNSSEC.type= "DNSSEC";
        // cnData.list.push(DNSSEC);
        // let PKI = res.PKI.CN;
        // PKI.type= "PKI";
        // cnData.list.push(PKI);
        // let SPF = res.SPF.CN;
        // SPF.type= "SPF";
        // cnData.list.push(SPF);
        // //俄罗斯
        // let rsData = {};
        // rsData.name = "Russia";
        // rsData.list = [];
        // let DNSSEC1 = res.DNSSEC.RS;
        // DNSSEC1.type= "DNSSEC";
        // rsData.list.push(DNSSEC1);
        // let PKI1 = res.PKI.RS;
        // PKI1.type= "PKI";
        // rsData.list.push(PKI1);
        // let SPF1 = res.SPF.RS;
        // SPF1.type= "SPF";
        // rsData.list.push(SPF1);
        // let resData = [];
        // resData.push(cnData);
        // resData.push(rsData);
        //   let newArray = resData.map((item,index) => ({
        //     ...item,
        //     value: item.list[index].score // 重命名 'score' 为 'value'  默认成第一个index=0的score的值了
        //   }));
        this.option3.series[0].data = resultArr;
        //   console.log(newArray);
        this.init();
        // console.log(res);
      });
    },
    init() {
      echarts.registerMap("world", world);
      const dom = document.getElementById("map");

      this.myChart = echarts.init(dom);
      this.startTooltipRotation();
      this.myChart.setOption(this.option3);

    },
    startTooltipRotation() {
      let index2 = 0; // 初始索引为0

      let dataLength = this.option3.series[0].data.length;

      let timer = "";
      const startRotation =()=>{
        timer = setInterval(() => {
          if (dataLength > 0) {
            this.myChart.dispatchAction({
              type: "hideTip"
            });

            this.myChart.dispatchAction({
              type: "showTip",
              seriesIndex: 0,
              dataIndex: index2
            });

            index2 = (index2 + 1) % dataLength; // 使用取余确保循环
          }
        }, 5000);
      };

      // 鼠标移入停止轮播
      this.myChart.on("mouseover", () => {
        clearInterval(timer); // 清除定时器停止轮播
      });

      // 鼠标移出继续轮播
      this.myChart.on("mouseout", () => {
        clearInterval(timer); // 清除定时器停止轮播
        startRotation(); // 重新启动轮播
      });

      // 初始启动轮播
      startRotation();
    }
  }
};

</script>
<style scoped lang='less'>
.box {
  width: 900px;
  height: 440px;
  position: absolute;
  left: 27%;
  top: 28%;
  z-index: 8;
}
</style>
